import { CommonModule } from '@angular/common';
import { Component, effect, inject } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { LucideAngularModule } from 'lucide-angular';
import { ButtonModule } from 'primeng/button';
import { ProgressBarModule } from 'primeng/progressbar';
import { TagModule } from 'primeng/tag';
import { TooltipModule } from 'primeng/tooltip';
import { LimitedFeatures } from 'src/app/shared/models/pack.models';
import { PackLimitationsService } from 'src/app/shared/services/pack-limitations.service';

@Component({
  selector: 'app-user-limit-indicator',
  imports: [
    CommonModule,
    ProgressBarModule,
    TagModule,
    TooltipModule,
    TranslocoModule,
    LucideAngularModule,
    ButtonModule,
  ],
  templateUrl: './user-limit-indicator.component.html',
})
export class UserLimitIndicatorComponent {
  private packLimitationService = inject(PackLimitationsService);
  users: number = 0;
  userLimit: number = 0;
  constructor() {
    effect(() => {
      this.users = this.packLimitationService.currentNumberOfUsers();
      this.userLimit = this.packLimitationService.userLimit();
    });
  }
  get progressPercentage(): number {
    if (this.userLimit === 0) return 0;
    return Math.round((this.users / this.userLimit) * 100);
  }
  get textColor() {
    if (this.progressPercentage > 90) return 'text-error-700';
    if (this.progressPercentage > 60) return 'text-warning-600';
    return 'text-validation-600';
  }
  openContactModal() {
    this.packLimitationService.openModal(LimitedFeatures.CreateUser);
  }
}
